import { toUserFriendlyAddress } from '@tonconnect/sdk'

/**
 * Нормализует адрес в user-friendly формат для сравнения
 */
export const normalizeAddress = (address: string): string => {
  try {
    // Если адрес в raw формате (workchain:hex) - конвертируем в user-friendly
    if (address.includes(':')) {
      const [workchain, hash] = address.split(':')
      const rawAddress = `${workchain}:${hash}`
      return toUserFriendlyAddress(rawAddress, false)
    }
    return address
  } catch {
    return address
  }
}

/**
 * Сравнивает два адреса кошельков, приводя их к одному формату
 */
export const compareWalletAddresses = (
  addr1: string,
  addr2: string,
): boolean => {
  const normalized1 = normalizeAddress(addr1).toLowerCase()
  const normalized2 = normalizeAddress(addr2).toLowerCase()
  return normalized1 === normalized2
}
